module.exports = __webpack_public_path__ + "img/income_term.52e3051.svg";